// @flow
import { Outlet } from 'react-router-dom';
import { compose } from 'redux';

import { withPageMeta } from '@gandi/app-runner';
import { needsAuth } from '@gandi/authentication';

import type { ComponentWithStaticMethods } from '../types';

// $FlowFixMe[incompatible-type]
export const CertificateLayout: ComponentWithStaticMethods<{}> = compose(
  needsAuth,
  withPageMeta(args => ({
    title: args.__('Buy SSL Certificates - Gandi.net'),
    description: args.__(
      'SSL Certificates - Secure your transactions with Gandi\'s large offer of certificates (free certificates, Organization validation, Extendend validation "Green bar")',
    ),
  })),
)(() => <Outlet />);
